import { OverlayTrigger, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './InfoTooltip.module.scss';

export function InfoTitle(props) {
  const { children, width, wide, content, disabled } = props;

  const withWidth = !!width || wide;
  const tooltipStyle = { width: width || undefined };

  const overlay = (
    <Popover className={cn(styles.tooltip, withWidth ? styles.withWidth : '')} style={tooltipStyle}>
      <Popover.Body>{content}</Popover.Body>
    </Popover>
  );

  if (disabled || content === '') return children;

  return (
    <OverlayTrigger placement="top" trigger={['hover', 'focus']} rootClose overlay={overlay}>
      {children}
    </OverlayTrigger>
  );
}

InfoTitle.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
  wide: PropTypes.bool,
  disabled: PropTypes.bool,
};
